import { useTranslation } from 'libs/i18n';
import { IconButton, Stack, Typography } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { useFormContext } from 'modules/client/legal/forms/companyBankAccountsForm';

interface Props {
  index: number;
  onRemoveBankAccount?: (index: number) => void;
}

export const Header = ({ index, onRemoveBankAccount }: Props) => {
  const { t } = useTranslation();
  const { readOnly } = useFormContext();

  const isFirst = index === 0;
  return (
    <Stack direction="row" spacing={12}>
      <Typography variant="bodyBold">
        {t(
          isFirst
            ? 'client.legal.companyBankAccounts.account'
            : 'client.legal.companyBankAccounts.accountOther'
        )}
      </Typography>
      {!readOnly && onRemoveBankAccount && !isFirst && (
        <IconButton
          colorVariant="red"
          icon={<Icon.Minus size={16} />}
          mode="outlined"
          sizeVariant="xs"
          onClick={() => onRemoveBankAccount?.(index)}
        />
      )}
    </Stack>
  );
};
